module.exports = __webpack_public_path__ + "static/CleanAir-Desktop-Header-1920x340-Curve-About-2x-4df631db17122adffbb23e19f8e2b7ef.png";